import spartaEventsUtility from '@sparta.global.utilities/sparta-events-utility/dist/es6.js';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "print-link-float-right";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"print-link-module\">\r\n  <button class=\"print-link "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"module") : depth0)) != null ? lookupProperty(stack1,"floatRight") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":28},"end":{"line":2,"column":82}}})) != null ? stack1 : "")
    + "\"\r\n    type=\"button\"\r\n  >\r\n    "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"data") : depth0)) != null ? lookupProperty(stack1,"print-page") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n  </button>\r\n</div>";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.global.modules/print-link-module",
  "version": "1.0.29",
  "id": "PrintLinkModule",
  "containerID": "globalPrintLinkModule",
  "moduleName": "global-print-link-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "print-link-module",
  "data": {
    "init": "PrintLinkModule"
  },
  "moduleParams": [{
    "name": "isChild",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": ""
  }, {
    "name": "site",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": ""
  }, {
    "name": "floatRight",
    "type": "boolean",
    "values": [true, false],
    "default": false,
    "description": "Floats the print link to the right"
  }],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.global.utilities/sparta-events-utility": "^1.0.6",
    "@sparta.global.utilities/sparta-module-utility": "^1.1.8",
    "@sparta.global.utilities/sparta-color-style-token-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-font-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/handlebars": "^4.7.7"
  },
  "stores": []
};

/**
 * Namespace for the utility.
 * @constant {string}
 */
const utilityNamespace = 'PrintLinkModule';
const printEventDelay = 500;
/**
 * Collection of namespaced event strings.
 * @constant {object}
 */
const EVENTS = {
  ON_WINDOW_PRINT: `ON_WINDOW_PRINT.${utilityNamespace}`
};

/**
 * Handles the display of the Print Link.
 */
class PrintLinkModule extends Module {
  /**
   * Creates an instance of the module.
   * @param {object} options - The options this module was initialized with.
   * @param {object} context - Context for the module.
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
  }

  /**
   * Called when this module is bootstrapped by the client.
   * @returns {void}
   */
  init() {
    // Get the module DOM element so we can attach listener.
    if (this.settings.$target) {
      const moduleElm = this.settings.$target[0];
      const trigger = moduleElm.querySelector('.print-link');
      if (trigger) {
        trigger.addEventListener('click', event => {
          // Publish event so sub events have a chance to fire.
          spartaEventsUtility.pub(EVENTS.ON_WINDOW_PRINT, {
            trigger,
            event
          });

          // After a delay, print screen.
          setTimeout(() => {
            window.print();
          }, printEventDelay);
        }, false);
      }
    }
  }
}
registerModuleClass({
  moduleClass: PrintLinkModule,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { PrintLinkModule as default, moduleConfig };
